<template>
  <div
    :class="pageControllerClass"
    ds-component="DsPageController"
  >
    <div
      class="page-controller__previous"
      @click="changePage(currentActivePage - 1)"
    >
      <DsIcon size="small" name="chevron-left" />
    </div>
    <div
      v-for="i in size"
      :key="i"
      :class="dotClass(i)"
      @click="changePage(i)"
    />
    <div
      class="page-controller__next"
      @click="changePage(currentActivePage + 1)"
    >
      <DsIcon size="small" name="chevron-right" />
    </div>
  </div>
</template>

<script lang="ts">
// @ts-nocheck

import Vue from 'vue';
import Tokens from '@ds/tokens';
import { DsIcon } from '@ds/icons';

export default Vue.extend({
  name: 'DsPageController',
  components: {
    DsIcon
  },
  model: {
    prop: 'position',
    event: 'update:model'
  },
  props: {
    size: {
      type: Number,
      default: 2,
      validator(size) {
        const isValid = size >= 2 && size <= 6;

        if (!isValid)
          throw new Error('"size" prop must to be an number between 2 and 6.');
        return isValid;
      }
    },
    position: {
      type: Number,
      default: 0,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentActivePage: 1
    };
  },
  computed: {
    pageControllerClass() {
      return {
        'page-controller': true,
        'page-controller--first': this.currentActivePage === 1,
        'page-controller--last': this.currentActivePage === this.size,
      };
    }
  },
  methods: {
    changePage(newPosition) {
      const position = this.newPositionHandler(newPosition);
      this.currentActivePage = position;
    },
    newPositionHandler(newPosition) {
      return newPosition >= 1 && newPosition <= this.size
        ? newPosition
        : this.currentActivePage;
    },
    eventHandler(from, to) {
      this.$emit('change', { from, to });
      this.$emit('update:model', to);
    },
    dotClass(index) {
      return {
        'page-controller__dot': true,
        'page-controller__dot--active': this.currentActivePage === index
      };
    },
  },
  watch: {
    currentActivePage($new, $old) {
      this.eventHandler($old, $new);
    }
  },
  mounted() {
    this.currentActivePage = this.newPositionHandler(this.position);
    document.documentElement.setAttribute('data-color-theme', this.dark ? 'dark' : '');
  }
});
</script>

<style lang="scss" scoped>
@import '~@ds/styles/PageController.scss';
</style>
